﻿class DetailsCloser extends HTMLElement {
  connectedCallback() {
    const details = this.querySelectorAll('details');
    details.forEach((el1) => {
      el1.addEventListener('toggle', (e) => {
        if (el1.hasAttribute('open')) {
          details.forEach((el2) => {
            if (el1 !== el2) {
              el2.removeAttribute('open');
            }
          });
        }
      });
    });
  }
}

customElements.define('details-closer', DetailsCloser);
